import { IS_STNET } from '@utils/Constants'
import { EmailType, UserData } from 'src/models/User'
import { AuthorizationUserType } from '../authorizationUserType'
import { get, post, put } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getUser
 */

export const UserResponseCode = {
  Success: 0,
  NewPasswordRequired: 1 << 0,
  EmailRequired: 1 << 1,
} as const
export type UserResponseCode = (typeof UserResponseCode)[keyof typeof UserResponseCode]

type UserResponseData = {
  code: number // UserResponseCode bitmask
  user: UserData
}

export const getUser = async (userId?: number) => {
  return await get<UserResponseData>('/v1/auth/info', { userId, isSTNet: IS_STNET })
}

//////////////////////////////////////////////////////////////////////
// POST
//////////////////////////////////////////////////////////////////////

/**
 * confirmPassword
 */

export type ConfirmPasswordParams = {
  email: string
  code: string
  password: string
}

export const confirmPassword = async (params: ConfirmPasswordParams) => {
  await post('/v1/auth/confirmForgotPassword', params, false)
}

/**
 * login
 */

export type GetUserFromEmailParams = {
  type: AuthorizationUserType
  email?: string
  loginCode?: string
  password: string
  userCode?: string
}

export const login = async (params: GetUserFromEmailParams) => {
  return await post<UserResponseData>('/v1/auth/login', { ...params, isSTNet: IS_STNET }, false)
}

/**
 * sendResetPasswordEmail
 */

export type SendResetPasswordEmailParams = {
  email: string
}

export const sendResetPasswordEmail = async (params: SendResetPasswordEmailParams) => {
  await post('/v1/auth/forgotPassword', params, false)
}

//////////////////////////////////////////////////////////////////////
// PUT
//////////////////////////////////////////////////////////////////////

/**
 * updateEmail
 */

export type UpdateEmailParams = {
  email: string
  emailType?: EmailType
  consumptionAlertThreshold?: number
  phoneNumber?: string
}

export const updateEmail = async (params: UpdateEmailParams) => {
  await put('/v1/auth/updateEmail', params)
}
